import MediaPlayerHeading from './MediaPlayerHeading';

export default MediaPlayerHeading;
